module.exports = __webpack_public_path__ + "img/imacena.74376612.png";